__webpack_require__.p = "/e-commerce-website-flipcart-clone-v1/";